import React, { useState, useEffect, useRef } from 'react';
import { Handle, Position } from 'reactflow';
import './CustomNode.css';

const CustomNode = ({ id, data }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [labelText, setLabelText] = useState(data.label);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleIconClick = (menuType) => {
    if (data.onMenuClick) data.onMenuClick({ id, data }, menuType);
  };
  
  const handleLabelChange = () => {
    if (data.onUpdateLabel && labelText.trim() !== '') {
        data.onUpdateLabel(id, labelText);
    } else {
        setLabelText(data.label); // Revert if empty
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLabelChange();
    } else if (e.key === 'Escape') {
      setLabelText(data.label);
      setIsEditing(false);
    }
  };

  const handleDelete = () => {
    if (window.confirm(`آیا از حذف صفحه "${data.label}" مطمئن هستید؟`)) {
        if (data.onDeletePage) data.onDeletePage(id);
    }
  };

  return (
    <div
      className="custom-node-body"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Handle type="target" position={Position.Top} style={{ background: '#a0aec0' }} />
      {isHovered && !isEditing && (
        <div className="node-menu">
          <div className="menu-item" title="تحقیق کلمات کلیدی" onClick={() => handleIconClick('keywords')}>💎</div>
          <div className="menu-item" title="تحلیل رقبا" onClick={() => handleIconClick('competitors')}>📊</div>
          <div className="menu-item" title="استراتژی محتوا" onClick={() => handleIconClick('content')}>📝</div>
          <div className="menu-item" title="لینک‌سازی" onClick={() => handleIconClick('links')}>🔗</div>
          <div className="menu-separator"></div>
          <div className="menu-item danger" title="حذف صفحه" onClick={handleDelete}>🗑️</div>
        </div>
      )}
      <div className="node-label" onDoubleClick={() => setIsEditing(true)}>
        {isEditing ? (
          <input
            ref={inputRef}
            value={labelText}
            onChange={(e) => setLabelText(e.target.value)}
            onBlur={handleLabelChange}
            onKeyDown={handleKeyDown}
            className="node-label-input"
          />
        ) : (
          data.label
        )}
      </div>
      <Handle type="source" position={Position.Bottom} style={{ background: '#a0aec0' }} />
    </div>
  );
};

export default React.memo(CustomNode);